import React from 'react';
import { FormattedMessage } from 'react-intl';

export default () => (
  <FormattedMessage
    id="login.header.welcome-back-to-idagio"
    defaultMessage="Welcome back to IDAGIO"
  />
);
